import * as React from 'react';
import cx from 'classnames';
import { useColProps } from './internal';
import * as styles from '../../styles/col.css';
export var Col = function Col(props) {
  var _useColProps = useColProps(props),
    col = _useColProps.col,
    hidden = _useColProps.hidden,
    offset = _useColProps.offset,
    offsetRight = _useColProps.offsetRight;
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles["col_".concat(col)], Boolean(offset) && [styles["col_offset_".concat(offset)]], Boolean(offsetRight) && styles["col_offset_right_".concat(offsetRight)])
  }, props.children);
};
Col.displayName = 'Col';